module.exports = __webpack_public_path__ + "img/16_89.c32e84c9.png";